import { render, staticRenderFns } from "./InputQuantPDV.vue?vue&type=template&id=1f07034a&scoped=true"
import script from "./InputQuantPDV.vue?vue&type=script&lang=js"
export * from "./InputQuantPDV.vue?vue&type=script&lang=js"
import style0 from "./InputQuantPDV.vue?vue&type=style&index=0&id=1f07034a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f07034a",
  null
  
)

export default component.exports